"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _coreVerticalStepper = require("@vfuk/core-vertical-stepper");
var _useQuestionnaireNavigation = require("../hooks/questionnaire/useQuestionnaireNavigation");
var _useConfig = _interopRequireDefault(require("../hooks/useConfig"));
var _useAppSelector = require("../hooks/useAppSelector");
var _uiSelectors = require("../store/ui/uiSelectors");
var _services = require("../services");
var _constants = require("../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const StepperContainer = _styledComponents.default.div`
  margin-bottom: 170px;
  height: 305px;
  & ul {
    max-height: 234px;
  }
  & li {
    margin-bottom: 13.5px;
  }
  & li::before {
    border: 2px solid #820000;
  }
  & li::after {
    max-height: 45px;
  }
  & h2 {
    white-space: nowrap;
    line-height: 30px;
  }
`;
const VerticalStepperComponent = () => {
  const {
    currentQuestionIndex,
    journeySteps
  } = (0, _useQuestionnaireNavigation.useQuestionnaireNavigation)();
  const recommendationSteps = (0, _useAppSelector.useAppSelector)(_uiSelectors.selectSteps) || [];
  const currentPage = (0, _useAppSelector.useAppSelector)(_uiSelectors.selectCurrentPage);
  const stepperSettings = (0, _useConfig.default)('uiSettings.stepper', {});
  const recommendationStep = _services.locale.localeString('Recommendation.RecommendationStep');
  const steps = (0, _react.useMemo)(() => (recommendationSteps === null || recommendationSteps === void 0 ? void 0 : recommendationSteps.length) > 0 ? [...recommendationSteps, {
    title: recommendationStep
  }] : [...journeySteps, {
    title: recommendationStep
  }], [recommendationSteps, journeySteps]);
  steps[steps.length - 1].isFinal = stepperSettings === null || stepperSettings === void 0 ? void 0 : stepperSettings.showVerticalStepper;
  const selectedStep = (0, _react.useMemo)(() => currentQuestionIndex > -1 ? currentQuestionIndex + 1 : steps.length, [currentQuestionIndex, steps]);
  const selectedCurrentStep = (0, _react.useMemo)(() => currentPage === _constants.PAGES.SUMMARY ? steps.length - 1 : selectedStep, [selectedStep, steps, currentPage]);
  const completedSteps = steps.map(step => {
    return steps.indexOf(step) < selectedCurrentStep - 1 || steps.indexOf(selectedCurrentStep) === steps.length - 1 ? {
      ...step,
      state: 'completed'
    } : step;
  });
  if (!journeySteps || (journeySteps === null || journeySteps === void 0 ? void 0 : journeySteps.length) === 0) return null;
  return /*#__PURE__*/_react.default.createElement(StepperContainer, {
    id: "vertical-stepper"
  }, /*#__PURE__*/_react.default.createElement(_coreVerticalStepper.VerticalStepper, {
    currentStep: selectedCurrentStep,
    steps: completedSteps,
    showAllStepContent: true
  }));
};
var _default = VerticalStepperComponent;
exports.default = _default;